import { Divider, Stack, Text } from '@ltvco/refresh-lib/theme';

import { Question } from 'api/communityBuzz/interfaces';

import { BEENVERIFIED_AI_USERNAME, isAIContributor } from './constants';
import { calculateTimeSince } from './utils';

interface QuestionDetailsProps {
  question?: Question;
  onOpenQADisplayModal?: () => void;
  setSelectedQuestion?: (question?: Question) => void;
}
export const QuestionDetails = ({
  question,
  onOpenQADisplayModal,
  setSelectedQuestion,
}: QuestionDetailsProps) => {
  const handleOpenQADisplayModal = () => {
    onOpenQADisplayModal?.();
    setSelectedQuestion?.(question);
  };

  return (
    <Stack width="100%">
      <Stack
        width="100%"
        spacing={1}
        onClick={handleOpenQADisplayModal}
        sx={{ cursor: 'pointer' }}
      >
        <Text variant="h5" mb={0}>
          {question?.body_md}
        </Text>
        <Stack direction="row" spacing={1}>
          <Text variant="body2" color="text.secondary">
            {calculateTimeSince(question?.created_at)}
          </Text>
          <Text variant="body2" color="text.secondary">
            •{' '}
            {isAIContributor(question?.source, question?.username)
              ? BEENVERIFIED_AI_USERNAME
              : question?.username}
          </Text>
        </Stack>
      </Stack>
      <Divider sx={{ mt: 2 }} />
    </Stack>
  );
};
